

import React from "react";
import JobDetails from "./jobDetails/JobDetails";
import Email from "./Email/Email";

const Article = () => {
    return <article style={{height:'100%', display:"flex", flexDirection:"column"}}>
        <JobDetails />
        <Email />
    </article >
}

export default React.memo(Article);